import ReceiptTable from './ReceiptTable';

export default ReceiptTable;
